import { http } from '../../config/axios'

 const findArquivoRegistro = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/arquivoregistro/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findArquivoRegistro', error)
      throw Error(error.response.data)
    })
}

export default findArquivoRegistro;
